<template>
  <div class="pb-section-container margin-top-16">
    <div
      :class="[
        'pbs-header-container',
        active ? 'active' : null,
      ]"
    >
      <button
        v-if="finishedSection.includes('exclusionDisclaimer') && !active"
        type="button"
        class="pbs-done-button"
        @click="changeActiveStepIdx(index)"
      >
        Edit
      </button>
      <button
        v-else-if="!active"
        type="button"
        class="pbs-button"
        @click="changeActiveStepIdx(index)"
      >
        Start
      </button>
      <button
        v-else
        type="button"
        class="pbs-close-button"
        @click="changeActiveStepIdx(-1)"
      >
        <img src="@shared/assets/img/setting/chevron-up.svg" alt="Close">
      </button>
      <div class="pbs-header">
        Exclusions & Disclaimer
      </div>
      <div
        v-if="finishedSection.includes('exclusionDisclaimer')"
        class="pbs-header-right-container"
      >
        <div class="pbs-check-container">
          <img src="@shared/assets/img/general/check-white.png" alt="Check">
        </div>
      </div>
    </div>
    <div
      :class="[
        'pbs-body-container exclusion-section',
        active ? 'active' : null,
      ]"
    >
      <div class="pbs-body">
        Set your exclusions and disclaimer information below.
      </div>
      <div class="pbs-title-container">
        <div class="pbs-title">
          Universal Disclaimer
        </div>
      </div>
      <div class="pbs-sub-header">
        Input disclaimer for your plans.
      </div>
      <div class="pbs-input-title">
        This will apply to all active plans
      </div>
      <div class="pbs-input-container">
        <textarea
          v-model="disclaimer"
          aria-label="disclaimer"
          class="pbs-textarea margin-top-8"
          :disabled="noDisclaimer"
        />
        <div
          :class="[
            'pbs-text-counter',
            disclaimer.length > 800 ? 'error-text' : null,
          ]"
        >
          {{ disclaimer.length }}/800 characters
        </div>
        <div class="pbs-checkbox-container margin-top-8">
          <input
            id="no-disclaimer"
            v-model="noDisclaimer"
            type="checkbox"
            class="pbs-checkbox"
          >
          <label
            for="no-disclaimer"
            class="pbs-checkbox-label"
          >
            No Disclaimer
          </label>
        </div>
      </div>
      <div class="pbs-button-container">
        <button
          type="button"
          class="pbs-grey-button"
          :disabled="disclaimer.length > 800
            || (disclaimer.length === 0 && !noDisclaimer)"
          @click="handleContinue"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'ExclusionDisclaimer',
  props: {
    editing: Boolean,
    index: Number,
    active: Boolean,
    changeActiveStepIdx: Function,
    plan: Object,
    updatePlan: Function,
    finishedSection: Array,
    partnerSettings: Object,
    markUnfinishedSection: Function,
    markFinishedSection: Function,
  },
  data() {
    return {
      disclaimer: '',
      noDisclaimer: false,
    };
  },
  watch: {
    plan(newPlan) {
      const {
        PLAN_DISCLAIMER,
      } = this.partnerSettings;
      if (!this.noDisclaimer) {
        this.disclaimer = newPlan.disclaimer || PLAN_DISCLAIMER || '';
        this.noDisclaimer = !newPlan.disclaimer && !PLAN_DISCLAIMER;
      }
    },
    disclaimer() {
      this.checkIfIncomplete();
    },
    noDisclaimer(val) {
      if (val) {
        this.disclaimer = '';
      }
      this.checkIfIncomplete();
    },
  },
  methods: {
    handleContinue() {
      this.changeActiveStepIdx(this.index + 1);
      const newPlan = {
        ...this.plan,
        disclaimer: this.disclaimer,
      };
      this.updatePlan(newPlan, 'exclusionDisclaimer');
    },
    checkIfIncomplete: debounce(function () {
      if (this.editing || this.finishedSection.includes('signUpBonus')) {
        let incomplete = false;
        if (this.disclaimer !== this.partnerSettings?.PLAN_DISCLAIMER) {
          incomplete = true;
        }
        if (this.noDisclaimer && this.partnerSettings?.PLAN_DISCLAIMER) {
          incomplete = true;
        }
        if (!this.noDisclaimer && !this.partnerSettings?.PLAN_DISCLAIMER) {
          incomplete = true;
        }
        if (incomplete) {
          this.markUnfinishedSection('exclusionDisclaimer');
        } else {
          this.markFinishedSection('exclusionDisclaimer');
        }
      }
    }),
  },
};
</script>
